import GetSiteUrls from '@/components/global/SiteUrls'

const useSiteApiUrl = () => {
  const urls = GetSiteUrls()
  return urls.ConfigSiteApiUrl
}

export default useSiteApiUrl
